<template>
	<div class="collection font">
		<el-table :data="tableData" :row-style="{height:'10px'}"
			:row-class-name="tableRowClassName" @row-click="onRowClick" style="width: 100%">
			<el-table-column prop="name" label="院校名称" width="100px">
			</el-table-column>
			<el-table-column prop="new" label="最新双选会" width="100px">
				<template slot-scope="scope">
					<div v-if="scope.row.last_meeting">
					{{scope.row.last_meeting.begin_date == scope.row.last_meeting.end_date ? timeFilter(scope.row.last_meeting.begin_date) : `${timeFilter(scope.row.last_meeting.begin_date)} - ${timeFilter(scope.row.last_meeting.end_date,true)}`}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="meeting_type" label="形式">
				<template slot-scope="scope">
					<div v-if="scope.row.last_meeting">{{scope.row.last_meeting.meeting_type}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="city_name" label="地点">
			</el-table-column>
			<el-table-column prop="education" label="学历">
			</el-table-column>
			<el-table-column prop="university_type" label="类型">
			</el-table-column>
			<el-table-column prop="manage_dept" label="主管部门">
			</el-table-column>
			<el-table-column prop="leaving_school" label="实习离校">
			</el-table-column>
			<el-table-column prop="jiubw" type="index" label="985" width="30px">
				<template slot-scope="scope">
					 <img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('985')!=-1" src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
					<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
				</template>
			</el-table-column>
			<el-table-column prop="eryy" label="211" width="30px">
				<template slot-scope="scope">
					 <img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('211')!=-1" src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
					<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
				</template>
			</el-table-column>
			<el-table-column prop="yiliu" label="一流大学" width="50px">
				<template slot-scope="scope">
					<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('一流大学')!=-1" src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
					<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
				</template>
			</el-table-column>
			<el-table-column prop="xuek" label="一流学科" width="50px">
				<template slot-scope="scope">
					<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('一流学科')!=-1" src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
					<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
				</template>
			</el-table-column>
			<el-table-column prop="yanjiu" label="研究生院" width="50px">
				<template slot-scope="scope">
					<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('研究生院')!=-1" src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
					<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
				</template>
			</el-table-column>
			<el-table-column prop="shuos" label="有硕士" width="45px">
				<template slot-scope="scope">
					<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('有硕士')!=-1" src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
					<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
				</template>
			</el-table-column>
			<el-table-column prop="boshi" label="有博士" width="45px">
				<template slot-scope="scope">
					<img v-if="scope.row.university_feature && scope.row.university_feature.indexOf('有博士')!=-1" src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
					<!-- <img v-else src="../assets/img/zf1.png" style="width:14px;height:14px;"></img> -->
				</template>
			</el-table-column>
			<el-table-column prop="shouc" label="收藏">
				<template slot-scope="scope">
					 <img v-if="scope.row.collect_flag==1" src="../assets/img/xing1.png" style="width:14px;height:14px;"></img>
					 <img v-if="scope.row.collect_flag!=1" src="../assets/img/xing2.png" style="width:14px;height:14px;"></img>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="guanz" label="关注" width="35px">
				<template slot-scope="scope">
					 <img v-if="scope.row.follow_flag==1" src="../assets/img/xin1.png" style="width:14px;height:14px;"></img>
					 <img v-if="scope.row.follow_flag!=1" src="../assets/img/xin2.png" style="width:14px;height:14px;"></img>
				</template>
			</el-table-column> -->
		</el-table>
		<div class="font flex all-justify-end align-center"
			style="margin: 10px 0;text-align: end;">
			<el-pagination hide-on-single-page layout="prev, pager, next,jumper" :page-size="30" :total="total" :current-page="page" @current-change="currentPage">
			</el-pagination>
			<!-- <div class="flex" style="margin-left: 10px;">
				<div :class="page==1?'ye1 color':'ye1'" @click="pages()">1</div>
				<div class="ye2">Go</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				page: 1,
				tableData: [],
				total: 0
			}
		},
		mounted() {
			this.query()
		},
		methods:{
			tableRowClassName({
				row,
				rowIndex
			}) {
				//把每一行的索引放进row
				row.index = rowIndex;
				this.index = rowIndex;
				// console.log(rowIndex,"row");
			},
			onRowClick(row, event, column) {
				if(event.label == '收藏'){
					if(this.tableData[row.index].collect_flag == 0){
						this.$axios
							.post(`/api/university/collect`,{
								api_token: window.localStorage.getItem('token'),
								university_id: row.id
							})
							.then((res) => {
								if(res.data.code == 200){
									this.tableData[row.index].collect_flag = 1
								}else{
									this.$message.error(res.data.msg)
								}
							});
					}else{
						this.$axios
							.post(`/api/university/unCollect`,{
								api_token: window.localStorage.getItem('token'),
								university_id: row.id
							})
							.then((res) => {
								if(res.data.code == 200){
									this.tableData[row.index].collect_flag = 0
								}else{
									this.$message.error(res.data.msg)
								}
							});
					}
				}else{
					// if(row.url_type == 2){
					// 	window.open(row.url)
					// }else{
						if(row.begin_date){
							window.localStorage.setItem('shuju',JSON.stringify(row.university))
						}else{
							window.localStorage.setItem('shuju',JSON.stringify(row))
						}
						window.open(`http://www.xiaozhaozhushou.net/`)
						// if(row.begin_date){
						// 	this.$router.push({path: '/',query: {
						// 		shuju: JSON.stringify(row.university)
						// 	}})
						// }else{
						// 	this.$router.push({path: '/',query: {
						// 		shuju: JSON.stringify(row)
						// 	}})
						// }
					// }
				}
			},
			pages(){
				if(this.page!=1){
					this.page=1;
				}else{
					this.page='';
				}
			},
			query(){
				this.$axios.get(`/api/user/collects?page_size=30&api_token=${window.localStorage.getItem('token')?window.localStorage.getItem('token'): ''}&page=${this.page}&page_size=10`).then(res => {
					this.tableData = res.data.data.list.map(val => {
						return {...val,collect_flag: 1}
					});
					this.total = res.data.data.total
				})
			},
			currentPage(val){
				this.page=val;
				this.query();
			}
		}
	}
</script>

<style>
	.el-table {
		border: 1px solid #EBEEF5;
		font-size: 12px !important;
	}
	
	.el-table td {
		padding: 6px 0px !important;
		margin: 6px !important;
		text-align: center;
	}
	
	.el-table th {
		margin: 0 10px !important;
		padding: 6px 0px !important;
		text-align: center;
	}
	
	.el-table thead {
		color: #000000;
		font-weight: 400 !important;
	}
	
	.el-table th>.cell {
		padding: 0;
	}
	
	.el-table .cell {
		padding: 0;
	}
	.el-pager>li {
		min-width: 24px !important;
		height: 20px;
		line-height: 20px;
		border: 1px solid #EBEEF5;
		margin: 5px;
		font-size: 12px;
		color: #999999;
	}
	
	.el-pager li.active {
		color: #42b983;
	}
	
	.el-pager li:hover {
		color: #42b983;
	}
	
	.el-pagination .btn-next,
	.el-pagination .btn-prev {
		border: 1px solid #EBEEF5;
		height: 20px;
		line-height: 20px;
	}
	
	.el-pagination {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	
	.el-pagination button:hover {
		color: #42b983;
	}
	.ye2,
	.ye1 {
		border: 1px solid #EBEEF5;
		height: 20px;
		line-height: 20px;
		padding: 0 4px;
		color: #999999;
		font-weight: 700;
	}
	
	.ye1 {
		padding: 0 8px;
	}
	
	.ye1:hover,
	.ye2:hover {
		color: #42b983;
	}
</style>
